export type FreshchatCRMConfig = {
  on: (event: FreshchatEvents, callback: (data?: unknown) => void) => void;
};

export type FreshchatWidgetMessengerConfig = {
  locale?: string;
  externalId?: string; // user's id unique to your system
  restoreId?: string | null;
  config?: FreshchatWidgetMessengerWidgetConfig;
};

export type FreshchatWidgetMessengerWidgetConfig = {
  disableNotifications?: boolean;

  headerProperty?: {
    backgroundColor?: string;
    foregroundColor?: string;
    hideChatButton?: boolean;
  };
};
export type FreshChatInit = Pick<
  FreshchatWidgetMessengerConfig,
  'externalId' | 'restoreId'
> & {
  setRestoreId?: (restoreId: string) => void;
  hideChatButton?: boolean;
};

export type FreshChatConfig = {
  on: (event: FreshchatEvents, callback: (data?: any) => void) => void;
  isOpen: () => boolean;
  open: (payload?: FreshchatOpenPayload) => void;
  close: () => void;
  isInitialized: () => boolean;
  isLoaded: () => boolean;
  destroy: () => void;
  hide: () => void;
  show: () => void;
  setExternalId: (externalId: string) => void;
  setConfig: (payload: FreshchatWidgetMessengerConfig) => void;
  trackPage: (url: string, title: string) => void;
  user: FreshchatUser;
};

export type FreshchatOpenPayload = {
  replyText?: string;
  name?: string;
  topicId?: string;
};

export type FreshchatUser = {
  get: (callback: (response: FreshchatUserDataResponse) => void) => void;
  create: (
    payload: FreshchatUserPayload,
    callback?: (data: FreshchatUserDataResponse) => void,
  ) => Promise<FreshchatUserResponse>;
  update: (payload: FreshchatUserPayload) => Promise<FreshchatUserResponse>;
  clear: () => Promise<FreshchatUserResponse>;
  isExists: () => Promise<FreshchatUserExistResponse>;
  setProperties: (params: FreshchatUserPayload) => void;
};

export type FreshchatUserPayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  phoneCountry?: string;
};

export type FreshchatUserResponse = {
  success: boolean;
  status: number;
};

export type FreshchatUserDataResponse = FreshchatUserResponse & {
  data?: {
    restoreId?: string;
    firstName?: string;
  };
};

export type FreshchatUserExistResponse = FreshchatUserResponse & {
  data?: boolean;
};

export enum FreshchatEvents {
  widgetOpened = 'widget:opened',
  widgetClosed = 'widget:closed',
  widgetLoaded = 'widget:loaded',
  widgetDestroyed = 'widget:destroyed',
  userCreated = 'user:created',
  unreadCountNotify = 'unreadCount:notify',
  messageSent = 'message:sent',
  messageReceived = 'message:received',
  csatReceived = 'csat:received',
  csatUpdated = 'csat:updated',
  downloadFile = 'download:file',
  userCleared = 'user:cleared',
  dialogOpened = 'dialog:opened',
  dialogClosed = 'dialog:closed',
}

export type InitWidgetConfig = Partial<
  Pick<FreshchatWidgetMessengerConfig, 'restoreId' | 'externalId'>
>;
